import { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import { endpoints } from "./apiConfig";
import { getAuthHeader } from "./session";

function beep() {
  try {
    const C = window.AudioContext || window.webkitAudioContext;
    const ctx = new C();
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.connect(g); g.connect(ctx.destination);
    o.frequency.value = 880; g.gain.value = 0.12;
    o.start();
    setTimeout(() => { o.stop(); ctx.close(); }, 300);
  } catch (e) { /* no audio available */ }
}

export function staffRole() {
  try { return JSON.parse(sessionStorage.getItem("staff") || "null")?.role || "owner"; } catch (e) { return "owner"; }
}

// Polls the online-orders lists every 5 seconds and beeps when a new order lands in "Pending payment".
export default function useOnlineOrders(enabled) {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const prev = useRef(null);
  const load = useCallback(() => {
    if (!getAuthHeader().Authorization) return Promise.resolve();
    return axios.get(endpoints.onlineOrders, { headers: getAuthHeader() })
      .then((res) => {
        if (prev.current !== null && res.data.counts.pending > prev.current) beep();
        prev.current = res.data.counts.pending;
        setData(res.data);
        setError("");
      })
      .catch((err) => setError(err.response?.data?.error || "Couldn't refresh online orders."));
  }, []);
  useEffect(() => {
    if (!enabled) return undefined;
    load();
    const t = setInterval(load, 5000);
    window.addEventListener("focus", load);
    return () => { clearInterval(t); window.removeEventListener("focus", load); };
  }, [enabled, load]);
  return { data, error, reload: load };
}
